<template>
  <div class="list">
    <table>
      <tbody>
        <tr v-for="l in onlineList" :key="l.path">
          <td class="date">{{new Date(l.date).toDateString().slice(4)}}</td>
          <td>
            <router-link v-if="!l.exlink" v-bind:to="l.path">{{l.header}}</router-link>
            <a v-else v-bind:href="l.exlink" target="_blank">{{l.header}}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "list",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    onlineList: function() {
      return this.list.filter(l => l.online);
    }
  }
};
</script>


<style>
.date {
  width: 8em;
  color: #5b6a77;
}

.list a {
  color: #1f2b38;
  text-decoration: none;
}
</style>
